var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${_vm.on ? 'on' : 'off'} ${_vm.hidden ? 'hidden' : ''}`},_vm._l((_vm.text),function(char,index){return _c('span',{staticClass:"typewriter-character",style:(_vm.staggerDelay(index))},[_vm._v(_vm._s(char))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }